import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import CommonLoading from '@src/components/common-loading';
import FriendRecallModalStore from './store';
import styles from './index.less';

const FriendRow = ({ friend, onRecall }) => (
  <div className={styles.friendRow} data-name="历史好友item">
    <div className={styles.description} data-name="左侧描述">
      <div className={styles.relationGroup} data-name="关系名称">
        <div className={styles.relationText} data-name="曾经的师弟">
          {friend.relationText}
        </div>
      </div>
      <div className={styles.nameGroup} data-name="好友名称">
        <div className={styles.roleName} data-name="名称六个字符">
          {friend.roleName}
        </div>
      </div>
    </div>
    <div className={styles.actionGroup} data-name="右侧按钮">
      {friend.invited ? (
        <div className={cx(styles.recallButton, styles.hiddenLayer)} data-name="未召回态: 一键召回" />
      ) : (
        <button
          className={cx(styles.recallButton, styles.hitArea, styles.visibleLayer)}
          data-name="未召回态: 一键召回"
          data-role="recall-friend"
          type="button"
          onClick={() => {
            onRecall(friend);
          }}
        />
      )}
      <div className={cx(styles.invitedAction, friend.invited ? styles.visibleLayer : styles.hiddenLayer)} data-name="已召回态: 已邀请" />
    </div>
  </div>
);

export const FriendRecallModalView = ({ onClose, store }) => {
  store.use(onClose);
  const isList = store.mode === 'list';
  const isConfirm = store.mode === 'confirm';
  const isSuccess = store.mode === 'success';

  return (
    <ModalContainer modalState={store.isOpen}>
      <div className={styles.root}>
        <div className={cx(styles.listModal, isList && styles.activeState)} data-name="弹窗-召回列表" role="dialog" aria-modal="true" aria-hidden={!isList}>
          <div className={styles.listBackground} data-name="召回列表-弹窗背景" />
          <button
            className={cx(styles.listClose, styles.hitArea)}
            data-name="关闭按钮"
            data-role="recall-close"
            type="button"
            disabled={store.submitting}
            onClick={() => {
              store.requestClose(onClose);
            }}
          />
          <button
            className={cx(styles.posterButton, styles.hitArea)}
            data-name="生成海报邀请其他好友按钮"
            data-role="create-poster"
            type="button"
            disabled={store.submitting}
            onClick={() => {
              store.createPosterInvite();
            }}
          />
          <div className={styles.footerCopyGroup} data-name="底部文案">
            <div
              className={styles.footerCopy}
              data-name="*上述名单仅为匹配到手机号码的少侠亲友， 根据社交情况，展示社交信息。"
              data-text={'*上述名单仅为匹配到手机号码的少侠亲友，\n根据社交情况，展示社交信息。'}
            >
              少侠点击“一键召回”，<br/>将通过电话短信方式发放邀约。
            </div>
          </div>
          <div className={styles.friendList} data-name="召回主体列表list">
            {store.loading && <CommonLoading delayShow={0} />}
            {!store.loading && store.loadSucceeded && store.friends.length === 0 && <div className={styles.emptyState}>暂无可召回好友</div>}
            {!store.loading &&
              store.loadSucceeded &&
              store.friends.map(friend => <FriendRow key={friend.relationType} friend={friend} onRecall={target => store.selectFriend(target)} />)}
          </div>
          <div className={styles.headerCopyGroup} data-name="顶部文案">
            <div
              className={styles.headerCopy}
              data-name="您作为《剑侠世界3》的老玩家，让我们沿着 旧日足迹，重温那些并肩、相识与难忘的江湖时刻。"
              data-text={'您作为《剑侠世界3》的老玩家，让我们沿着\n旧日足迹，重温那些并肩、相识与难忘的江湖时刻。'}
            >
              您作为《剑侠世界3》的老玩家，让我们沿着<br />旧日足迹，重温那些并肩、相识与难忘的江湖时刻。
            </div>
          </div>
        </div>

        <div
          className={cx(styles.confirmModal, isConfirm && styles.activeState)}
          data-name="弹窗-召回确认"
          role="dialog"
          aria-modal="true"
          aria-hidden={!isConfirm}
        >
          <div className={styles.confirmBackground} data-name="召回确认-弹窗背景" />
          <div className={styles.confirmCopy} data-name="召回确认文案" />
          <button
            className={cx(styles.stateClose, styles.hitArea)}
            data-name="按钮-关闭弹窗"
            data-role="confirm-close"
            type="button"
            disabled={store.submitting}
            onClick={() => {
              store.cancelConfirm();
            }}
          />
          <button
            className={cx(styles.confirmButton, styles.hitArea)}
            data-name="按钮-确认发送"
            data-role="confirm-recall"
            type="button"
            disabled={store.submitting}
            onClick={() => {
              store.confirmRecall();
            }}
          />
        </div>

        <div
          className={cx(styles.successModal, isSuccess && styles.activeState)}
          data-name="弹窗-召回成功"
          role="dialog"
          aria-modal="true"
          aria-hidden={!isSuccess}
        >
          <div className={styles.successBackground} data-name="恭喜您" />
          <div className={styles.successCopy} data-name="召回成功文案" />
          <button
            className={cx(styles.stateClose, styles.hitArea)}
            data-name="按钮-关闭弹窗"
            data-role="success-close"
            type="button"
            onClick={() => {
              store.returnToList();
            }}
          />
          <button
            className={cx(styles.acknowledgeButton, styles.hitArea)}
            data-name="按钮-我知道了"
            data-role="success-acknowledge"
            type="button"
            onClick={() => {
              store.returnToList();
            }}
          />
        </div>
      </div>
    </ModalContainer>
  );
};

export default wrapStore(FriendRecallModalView, FriendRecallModalStore);
